import React, { useEffect, useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';

const Reytingler = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const navigate = useNavigate();

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);

        if (!storedIsLoggedIn) {
            navigate('/login');
        }
    }, [navigate]);

    return (

        <div className="breadcrumb-section breadcrumb-bg">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 text-center">
                    <div className="breadcrumb-text">
                        <p></p>
                        <h1>Reyting Tabloları</h1>
                    </div>
                    <div className="hero-btns">
                                                <Link to="/acilisreyting" className="boxed-btn">Açılış Reyting</Link>
                                                <Link to="/kapanisreyting" className="bordered-btn">Kapanış Reyting</Link>
                                            </div>
                </div>
            </div>
        </div>
    </div>
        
    );
};

export default Reytingler;
